import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'

class LocationsHero extends React.Component {
  constructor() {
    super()
    this.state = {
      visible: false
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        visible: true
      })
    }, 1000)
  }
  render () {
    const {
      titleOne,
      titleTwo,
      headerImages
    } = this.props
    return (
      <div className={cx('locations__hero rel mxa', {
        'is-animated': this.state.visible
      })}>
        <div className='container--xl ma p15'>
          <h1 className='m0 p0 animate a-t a-o a-d-2'>{titleOne}</h1>
          <h1 className='m0 p0 animate a-t a-o a-d-4'>{titleTwo}</h1>
        </div>
        <div className='locations__hero-images'>
          {headerImages.map(image => (
            <Image key={image._key} className='animate a-o a-t' imageId={image.imageId} />
          ))}
        </div>
      </div>
    )
  }
}

export default LocationsHero